import React, {useEffect, useState} from "react";
import styles from "./CoverPreview.module.scss";
import {CaretRightOutlined, CloseOutlined} from "@ant-design/icons";
import {getUrl} from "src/service/files.service";
import {getUrlParameter} from "src/service/util.service";
import {checkEmpty} from "src/utils/janus.utils";

//coverUrl,handleCloseCover,coverType,width,height,
const CoverPreview = (props: any) => {
  const {
    onClick,
    close,
    coverUrl,
    handleCloseCover,
    coverType,
    width,
    height,
    backgroundSize,
    margin,
    more,
    coverExtension,
    id,
  } = props;

  const [url1024, setUrl1024] = useState("");
  const [urlvideo, setUrlvideo] = useState("");

  const getShape = (source: string) => {
    let img = new Image();
    img.src = source;
    if (img.width > img.height) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    checkGetUrlFile100();
    checkGetUrlFile1024();
  }, [coverUrl, coverType]);

  const checkGetUrlFile1024 = async () => {
    let url: any = coverUrl;
    console.log("coverUrl", coverUrl);

    if (coverUrl?.indexOf("&size=") == -1 && coverUrl?.indexOf("blob=") != -1)
      url = coverUrl;
    if (coverType === "image") {
      let id = getUrlParameter("fileId", url);
      if (!checkEmpty(id)) {
        url = await getUrl(url, id, 1024, "post");
      }
    }
    setUrl1024(url);
  };

  const checkGetUrlFile100 = async () => {
    let url: any = coverUrl;
    if (coverUrl?.indexOf("&size=") == -1 && coverUrl?.indexOf("blob=") != -1) {
      url = coverUrl + "&size=1024";
    }
    if (coverType === "video") {
      let id = getUrlParameter("fileId", url);
      if (!checkEmpty(id)) {
        url = await getUrl(url, id, 1024, "post");
        let size = getUrlParameter("size", url);
        if (checkEmpty(size) && url?.indexOf("FileService") !=-1) {
          url = url + "&size=1024";
        }
      }
    }
    setUrlvideo(url);
  };

  return (
    <>
      {coverType === "image" && (
        <div
          id={"peview_create_post_" + id}
          style={{
            width: "100%",
            height: height ? height : "auto",
            display: "flex",
          }}
        >
          <div
            id={"peview_create_post_inside_" + id}
            className={styles.coverPreview}
            style={{
              position: "relative",
              backgroundImage: `url(${url1024})`,
              backgroundSize: backgroundSize ? backgroundSize : "",
              width: width ? width : "100%",
              height: height ? height : "100px",
              margin: margin ? margin : "",
              backgroundPosition: "center",
              // borderRadius: "5%",
              backgroundPositionX: "center",
              // backgroundPositionY: getShape(url1024) ? "0px" : "top",
            }}
            onClick={onClick}
          >
            {more && (
              <div className={styles.more} style={{}}>
                +{more}
              </div>
            )}
          </div>
          {close && (
            <div style={{ position: "relative" }}>
              <div
                className={styles.closeCover}
                onClick={() => handleCloseCover(url1024)}
              >
                <CloseOutlined className={styles.innerCloseCover} />
              </div>
            </div>
          )}
        </div>
      )}

      {coverType === "video" && (
        <div
          className={styles.coverPreview}
          style={{
            position: "relative",
            backgroundImage: `url(${urlvideo})`,
            width: width ? width : "100%",
            height: height ? height : "100px",
            margin: margin ? margin : "",
            backgroundPosition: "center",
            backgroundSize: "contain",
          }}
          onClick={onClick}
        >
          {close && (
            <video
              muted
              style={{
                width: width ? width : "158px",
                height: height ? height : "100px",
                margin: margin ? margin : "",
                position: "relative",
                borderRadius: 10,
              }}
            >
              <source src={coverUrl} type="video/mp4" />
              Your browser does not support HTML5 video.
            </video>
          )}
          {close && (
            <div
              className={styles.closeCover}
              onClick={() => handleCloseCover(coverUrl)}
            >
              <CloseOutlined className={styles.innerCloseCover} />
            </div>
          )}

          <div className={styles.playVidBtn}>
            <div
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              <CaretRightOutlined
                className={styles.playVideo}
                style={{ fontSize: 70, color: "#FFFFFF" }}
              />
            </div>
          </div>

          {/* <div style={{ width: "100%", position: "absolute" }}> */}
          {/* </div> */}
        </div>
      )}
    </>
  );
};

export default CoverPreview;
